import {PAYMENT_TYPE_APPLEPAY, PAYMENT_TYPE_BANCONTACT, PAYMENT_TYPE_CREDITCARD, PAYMENT_TYPE_GOOGLEWALLET, PAYMENT_TYPE_IDEAL, PAYMENT_TYPE_MAESTRO, PAYMENT_TYPE_ONSITE, PAYMENT_TYPE_ZERO} from './../../AppConstants';
import {areThereAnyNonEntryProductsInBooking, areThereAnyTreatmentProductsInBooking, isPriceZero} from '../booking/booking.scenarios.select.svelte.js';
import {booker} from './feature.booker.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import DateTimeUtil from "../../utils/DateTimeUtil.js";

export function getAllowedPaymentMethods()
{
  let aResponse = [];
  const bIsPackageDeal = booking.iCurrentSelectedPackagedealID !== 0;
  const bContainsNonEntryProduct = areThereAnyNonEntryProductsInBooking();
  const bContainsTreatments = areThereAnyTreatmentProductsInBooking();
  const bIsPriceZero = isPriceZero();

  const bIsEntreeOnly = (
    !bIsPackageDeal &&
    !bContainsNonEntryProduct &&
    // booking?.bShowListOfPackageDeals !== true &&
    booker?.bInsurance === false
  );

  const sArrivalDate = booking?.sArrivalDate; // format: 31-03-2019
  const aAdHocDaysWhereOnlyPaymentMethodIsOnline = [
    '25-12-2024',
    '26-12-2024',
    '25-12-2025',
    '26-12-2025',
    '25-12-2026',
    '26-12-2026'
  ];

  const bIsOnlinePaymentOnlyDay = aAdHocDaysWhereOnlyPaymentMethodIsOnline.includes(sArrivalDate);

  // console.log('getAllowedPaymentMethods', bContainsTreatments, bIsOnlinePaymentOnlyDay, bIsPackageDeal, booker?.bInsurance);
  // Als er een niet-entreeproduct in de boeking zit, is onsite betaling niet meer mogelijk
  if ( bContainsTreatments || bIsOnlinePaymentOnlyDay )
  {
    aResponse.push(PAYMENT_TYPE_IDEAL, PAYMENT_TYPE_CREDITCARD, PAYMENT_TYPE_MAESTRO, PAYMENT_TYPE_BANCONTACT, PAYMENT_TYPE_GOOGLEWALLET, PAYMENT_TYPE_APPLEPAY);
  }
  else
  {
    aResponse.push(PAYMENT_TYPE_IDEAL, PAYMENT_TYPE_CREDITCARD, PAYMENT_TYPE_MAESTRO, PAYMENT_TYPE_BANCONTACT, PAYMENT_TYPE_GOOGLEWALLET, PAYMENT_TYPE_APPLEPAY);

    if ( !bIsPackageDeal && !booker?.bInsurance )
    {
      // JB: als je komt op maandag, dinsdag, woensdag en donderdag kun je nog betalen aan de balie.. in het weekend niet meer
      // Sunday = 0, Saturday = 6
      if ( booking.sArrivalDate
        && [1, 2, 3, 4].includes(DateTimeUtil.getWeekDayNumber(booking.sArrivalDate)) )
      {
        aResponse.push(PAYMENT_TYPE_ONSITE);
      }
    }
  }

  if ( bIsPriceZero )
  {
    aResponse = [PAYMENT_TYPE_ZERO]; // Als het bedrag 0 is, hoeft er niet afgerekend te worden
  }

  // console.log('betaalmethoden', aResponse);
  return aResponse;
}

export function getMergedManualAndGeneratedComments()
{
  return booker?.sComments || '';
  // Hier worden extra onderdelen toegevoegd als nodig
}
